module.exports = __webpack_public_path__ + "static/media/Alaska_1440.188b39b2.png";